import { createContext, useContext } from "react";
import getSymbolFromCurrency from "currency-symbol-map";

export const CurrencyContext = createContext<{
    currencyCode: string;
    currencySymbol: string;
}>({
    currencyCode: "GBP",
    currencySymbol: "H",
});

export function CurrencyProvider({
    children,
    currencyCode,
}: {
    children: React.ReactNode;
    currencyCode: string;
}) {
    const currencySymbol = getSymbolFromCurrency(currencyCode) || "£";

    return (
        <CurrencyContext.Provider value={{ currencyCode, currencySymbol }}>
            {children}
        </CurrencyContext.Provider>
    );
}

export function useCurrency() {
    return useContext(CurrencyContext);
}
